module.exports = __webpack_public_path__ + "products-33612c4d/image-with-message-illustration-2-048846035a51a87dc2973b537d7dc23d.png";